import React from "react";
import styled from "styled-components/macro";
import { device } from "./../device";

const PopUpItem = ({
  item: { image, title, model, description, category, link },
  quantity,
}) => {
  return (
    <Wrapper>
      <ItemWrapper>
        <ItemImg src={image} alt={"Item"} />
        <TextArea>
          <Title>{title}</Title>
          {model && <Text>{model}</Text>}
          {description && (
            <Text style={{ margin: "10px 0" }}>{description}</Text>
          )}
          <Text>{`Quantity: ${quantity.count}`}</Text>
          <Text>{category}</Text>
        </TextArea>
      </ItemWrapper>

      {link && (
        <div
          style={{
            display: "flex",
            position: "relative",
            width: "100%",
            justifyContent: "space-around",
          }}
        >
          <ButtonRound
            variant="outlined"
            style={{ marginTop: "10px", color: "#4b4b4b" }}
            onClick={() => window.open(link, "_blank")}
          >
            Learn More
          </ButtonRound>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  box-shadow: 2px 3px 15px 4px rgba(0, 0, 0, 0.3);
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  background-color: white;
  justify-content: center;
  @media ${device.mobileS} {
    max-width: 130px;
    padding: 10px;
    text-align: center;
  }
  @media ${device.tablet} {
    max-width: 450px;
    padding: 15px;
    text-align: left;
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  position: relative;
  @media ${device.mobileS} {
    flex-direction: column;
    align-items: center;
  }
  @media ${device.tablet} {
    flex-direction: row;
    flex-wrap: nowrap;
  }
`;

const ItemImg = styled.img`
  object-fit: contain;
  @media ${device.mobileS} {
    width: 88px;
    height: 88px;
  }
  @media ${device.tablet} {
    width: 111px;
    height: 111px;
  }
`;

const TextArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  @media ${device.mobileS} {
    padding-left: 0px;
  }
  @media ${device.tablet} {
    padding-left: 10px;
  }
`;

const Title = styled.div`
  color: #4b4b4b;
  font-weight: bolder;
  line-height: 1.5;
  font-family: Manrope, serif;
  margin-bottom: 5px;
  @media ${device.mobileS} {
    font-size: 14px;
  }
  @media ${device.tablet} {
    font-size: 18px;
  }
`;

const Text = styled.div`
  color: #4b4b4b;
  line-height: 1.5;
  font-family: Manrope, serif;
  @media ${device.mobileS} {
    font-size: 10px;
  }
  @media ${device.tablet} {
    font-size: 15px;
  }
`;

const ButtonRound = styled.span`
  margin-top: 10px;
  color: #000000;
  border: 1px solid #000000;
  padding: 5px 15px;
  border-radius: 45px;
  cursor: pointer;
  @media ${device.mobileS} {
    font-size: 10px;
  }
  @media ${device.tablet} {
    font-size: 15px;
  }
`;

export { PopUpItem };
